export default __webpack_public_path__ + "static/media/IC00038-search.7f5fbb06.svg";